import Alpine from "alpinejs";
import Cart from "../components/CartCustom";

Alpine.data("CartDrawer", Cart);
